import React, { Component } from "react";
import Radio from "./../../../common/Radio/Radio";
import RequestStateUpdateModal from "./RequestStateUpdateModal";
import find from "lodash/find";
import sortBy from "lodash/sortBy";
import uniqueId from "lodash/uniqueId";
import { toast } from "react-toastify";
import ConfirmationModalSmall from "../../../components/ServicePackaging/ConfirmationModalSmall";
import copysvg from "../../../assets/arrow_copy.svg"

class MyServiceRequestStatusProgression extends Component {
	constructor(props) {
		super(props);
		this.state = {
			headerTitle: this.props.title,
			currentProgressionOrder: 0,
			recalculateURL: null,
		};
	}

	componentDidMount() {
		const currentProgressionOrder = this.getProgressionOrder(
			this.props.currentState
		);
		this.setState({ currentProgressionOrder });
	}

	// componentDidUpdate() {
	// 	this.props.getMyServiceRequestsForInterval()
	// }

	

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.props.currentState !== nextProps.currentState) {
			const currentProgressionOrder = this.getProgressionOrder(
				nextProps.currentState
			);
			this.setState({ currentProgressionOrder });
		}
	}

	getProgressionOrder = (sSRState) => {
		const state = find(this.props.masterServiceRequestStates, { sSRState });
		return state ? state.nOrder : -1;
	};

	partialPendingOrder = () => {
		const { masterServiceRequestStates } = this.props;
		const state = find(masterServiceRequestStates, {
			sSRState: "Partial/ Full Payment Pending",
		});
		return state ? state.nOrder : -1;
	};

	paymentReceivedOrder = () => {
		const { masterServiceRequestStates } = this.props;
		const isPaymentAvailable =
			this.props.serviceRequestReadOnlyData?.sPaymentStatus === "Payment Link Deactivated" ||
			this.props.serviceRequestReadOnlyData?.sPaymentStatus === "Credit" ||
			!!this.props.serviceRequestReadOnlyData?.sNEFTDetails ||
			!!this.props.serviceRequestReadOnlyData?.sNEFTTxnId_1 ||
			this.props.serviceRequestReadOnlyData?.bNEFTPayment === true;
		if(isPaymentAvailable !== false){
		const state = find(masterServiceRequestStates, {
			sSRState: "Payment Received",
		});
		return state ? state.nOrder : -1;
		}
	};
	// paymentReceivedOrder = () => {
	// 	const { masterServiceRequestStates } = this.props;
	// 	const isPaymentAvailable =
	// 		this.props.serviceRequestReadOnlyData?.sPaymentStatus === "Payment Link Deactivated" ||
	// 		this.props.serviceRequestReadOnlyData?.sPaymentStatus === "Credit" ||
	// 		!!this.props.serviceRequestReadOnlyData?.sNEFTDetails ||
	// 		!!this.props.serviceRequestReadOnlyData?.sNEFTTxnId_1 ||
	// 		this.props.serviceRequestReadOnlyData?.bNEFTPayment === true;

	// 	if (isPaymentAvailable) {
	// 		const state = find(masterServiceRequestStates, {
	// 			sSRState: "Payment Received",
	// 		});

	// 		return state ? state.nOrder : -1;
	// 	}

	// 	return -1;
	// };

	getPaymentLinkAndNeftView = (currentProgressionOrder) => {
		const nPackageInstanceId = this.props.nPackageInstanceId;
		const isDisabled = currentProgressionOrder >= this.paymentReceivedOrder();
		const isSudhirGijare =
  this.props?.serviceRequestReadOnlyData?.refExternalServicePartner === "Mr. Sudhir Gijare" ||
  this.props?.serviceRequestReadOnlyData?.ext_sp_org === "Mr. Sudhir Gijare";
  const serviceData = this.props.serviceRequestReadOnlyData;

		const isLongTermPackage =
			serviceData?.sPackageOfferTitle === "Long Term Engagement Package";
		// console.log('this.props?.serviceRequestReadOnlyData',this.props?.serviceRequestReadOnlyData,'refExternalServicePartner:',this.props?.serviceRequestReadOnlyData?.refExternalServicePartner, (this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" && (this.props?.serviceRequestReadOnlyData?.refExternalServicePartner !== 'Mr. Sudhir Gijare' || this.props?.serviceRequestReadOnlyData?.ext_sp_org !== 'Mr. Sudhir Gijare')))
		// let isNeftDisabled =
		// 	this.props.deliveryMode === "Self-Served" ||
		// 	this.props.paymentMode === "No_Payment" ||
		// 	this.props.paymentMode === "SP_paid_service" ||
		// 	// (this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "deAsra" && !isSudhirGijare) ||
		// 	(this.props.nPackageInstanceId === null && this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" && !isSudhirGijare)||
		// 	this.props?.serviceRequestReadOnlyData?.sPackageOfferTitle == 'Long Term Engagement Package' ||
		// 	this.props.serviceRequestReadOnlyData.bNEFTPayment ||
		// 	isDisabled;
		let isNeftDisabled =
			this.props.deliveryMode === "Self-Served" ||
			this.props.paymentMode === "No_Payment" ||
			this.props.paymentMode === "SP_paid_service" ||
			(
				this.props.nPackageInstanceId === null &&
				this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" &&
				!isSudhirGijare
			) ||
			(
				this.props?.serviceRequestReadOnlyData?.sPackageOfferTitle === "Long Term Engagement Package" &&
				this.props?.serviceRequestReadOnlyData?.sPaymentReceiver !== "deAsra"
			) ||
			this.props.serviceRequestReadOnlyData.bNEFTPayment ||
			isDisabled;

		// let isPaymentLinkDisabled =
		// 	this.props.deliveryMode === "Self-Served" ||
		// 	this.props.paymentMode === "No_Payment" ||
		// 	this.props.paymentMode === "SP_paid_service" ||
		// 	// this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" ||
		// 	(this.props.nPackageInstanceId === null && this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" && !isSudhirGijare)||
		// 	this.props.serviceRequestReadOnlyData?.sPackageOfferTitle == 'Long Term Engagement Package' ||
		// 	!this.props.catalogueId ||
		// 	this.props.serviceRequestReadOnlyData.bNEFTPayment ||
		// 	isDisabled;
		let isPaymentLinkDisabled =
			this.props.deliveryMode === "Self-Served" ||
			this.props.paymentMode === "No_Payment" ||
			this.props.paymentMode === "SP_paid_service" ||
			(
				this.props.nPackageInstanceId === null &&
				this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" &&
				!isSudhirGijare
			) ||
			(
				this.props?.serviceRequestReadOnlyData?.sPackageOfferTitle === "Long Term Engagement Package" &&
				this.props?.serviceRequestReadOnlyData?.sPaymentReceiver !== "deAsra"
			) ||
			!this.props.catalogueId ||
			this.props.serviceRequestReadOnlyData?.bNEFTPayment ||
			isDisabled;

		if (!isDisabled && nPackageInstanceId && !isLongTermPackage || (isLongTermPackage && this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" && isSudhirGijare) && this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner")
			if (this.props.packageType === "Paid" || this.props.packageType === "Dynamic" || (this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" && isSudhirGijare)) {
				isPaymentLinkDisabled = false;
				isNeftDisabled = false;
			}else if(this.props.nPackageInstanceId === null && this.props.packageType === "Paid" || this.props.packageType === "Dynamic" || this.props.packageType === "Partner Paid"){
				isPaymentLinkDisabled = false;
				isNeftDisabled = false;
			} else {
				isPaymentLinkDisabled = true;
				isNeftDisabled = true;
			}
		// const isNeftDisabled = currentProgressionOrder >= this.paymentReceivedOrder();
		let paymentStatus = "";
		if (this.props.paymentStatus === "Credit")
			paymentStatus = "Payment Received";
		else if (this.props.paymentStatus === "Failed")
			paymentStatus = "Payment Failed";
		else if (this.props.paymentStatus === "Payment Link Deactivated")
			paymentStatus = "Payment Link Deactivated";
		else if (this.props.paymentURL !== null) paymentStatus = "Payment Pending";
		else paymentStatus = "Not Sent";

		const copyToClipboard = (content) => {
			const el = document.createElement('textarea');
			el.value = content;
			document.body.appendChild(el);
			el.select();
			document.execCommand('copy');
			document.body.removeChild(el);
		};

		return (
			<div
				className="flex justify-content-around ml-1"
				style={{ flexDirection: "column" }}
				key={uniqueId()}
			>
				<div
					id="openNEFTDropdownLPM"
					className={`underlined-action ${isNeftDisabled && "disabled"}`}
					onClick={this.props.toggleNeftModal}
				>
					{this.props.isDisabled ? "View NEFT Details" : "Add NEFT Details"}
				</div>
				<div
					style={{
						display: "flex",
						// alignItems: "center",
						justifyContent: "space-between",
					}}
				>
					{this.props.bCouponApplied && this.props.dtCouponExpiryDate ? (
						<>
							{new Date(this.props.dtCouponExpiryDate) < new Date() ? (
								<div
									// className={`underlined-action 
									// 		${isPaymentLinkDisabled && "disabled"}`}
									// onClick={this.props.toggleConfirmationModal}
									className="d-flex"
								>
									<p
										className={`underlined-action 
											${isPaymentLinkDisabled && "disabled"}`}
									onClick={this.props.toggleConfirmationModal}
									>
										Send Payment Link
									</p>
									{this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" &&
										(
											this.props?.serviceRequestReadOnlyData?.nPackageInstanceId === null ||
											(
												this.props?.serviceRequestReadOnlyData?.nPackageInstanceId !== null &&
												this.props?.serviceRequestReadOnlyData?.sPackageOfferTitle === "Long Term Engagement Package"
											)
										) &&
										this.props?.serviceRequestReadOnlyData?.refExternalServicePartner !== "Mr. Sudhir Gijare" &&
										this.props?.serviceRequestReadOnlyData?.ext_sp_org !== "Mr. Sudhir Gijare" ?

										""
										:
									<p>
										{
											this.props.paymentURL && this.props.paymentStatus !== "Payment Link Deactivated" ? (
												<>
													<img
														alt="copy"
														title="Copy Payment Link"
														src={copysvg}
														height={"20px"}
														width={"16px"}
														className="con-cursor-pointer conv-mr13 conv-ml10"
														onClick={(e) => {
															e.preventDefault();

															if(this.props.paymentURL){
																copyToClipboard(this.props.paymentURL);
																toast(`Payment Link Copied!`, {
																	autoClose: 5000,
																	type: toast.TYPE.SUCCESS,
																})
															}else{
																toast(`No payment link found`, {
																	autoClose: 5000,
																	type: toast.TYPE.SUCCESS,
																})
															}
														}}
													/> 
													{/* <small>(copy payment link)</small> */}
												</>
											) : ""
										}
										
									</p>
								}
								</div>
							) : (
								<div
									// className={`underlined-action 
									// 		${isPaymentLinkDisabled && "disabled"}`}
									// onClick={this.props.onSendPaymentLink}
									className="d-flex"
								>
									<p
										className={`underlined-action 
											${isPaymentLinkDisabled && "disabled"}`}
										onClick={this.props.onSendPaymentLink}
									>
										Send Payment Link
									</p>
										{this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" &&
											(
												this.props?.serviceRequestReadOnlyData?.nPackageInstanceId === null ||
												(
													this.props?.serviceRequestReadOnlyData?.nPackageInstanceId !== null &&
													this.props?.serviceRequestReadOnlyData?.sPackageOfferTitle === "Long Term Engagement Package"
												)
											) &&
											this.props?.serviceRequestReadOnlyData?.refExternalServicePartner !== "Mr. Sudhir Gijare" &&
											this.props?.serviceRequestReadOnlyData?.ext_sp_org !== "Mr. Sudhir Gijare" ?

											""
											:
									<p>
										{
											this.props.paymentURL && this.props.paymentStatus !== "Payment Link Deactivated" ? (
												<>
													<img
														alt="copy"
														title="Copy Payment Link"
														src={copysvg}
														height={"20px"}
														width={"16px"}
														className="con-cursor-pointer conv-mr13 conv-ml10"
														onClick={(e) => {
															e.preventDefault();

															if(this.props.paymentURL){
																copyToClipboard(this.props.paymentURL);
																toast(`Payment Link Copied!`, {
																	autoClose: 5000,
																	type: toast.TYPE.SUCCESS,
																})
															}else{
																toast(`No payment link found`, {
																	autoClose: 5000,
																	type: toast.TYPE.SUCCESS,
																})
															}
														}}
													/> 
													{/* <small>(copy payment link)</small> */}
												</>
											): ""
										}

									</p>
							}
								</div>
							)}
						</>
					) : (
						<div
							// className={`underlined-action 
							// 	${isPaymentLinkDisabled && "disabled"}`}
							// onClick={this.props.onSendPaymentLink}
							className=" d-flex"
						>
							<p
								className={`underlined-action 
									${isPaymentLinkDisabled && "disabled"}`}
								onClick={this.props.onSendPaymentLink}
							>
								Send Payment Link
							</p>
								{this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" &&
									(
										this.props?.serviceRequestReadOnlyData?.nPackageInstanceId === null ||
										(
											this.props?.serviceRequestReadOnlyData?.nPackageInstanceId !== null &&
											this.props?.serviceRequestReadOnlyData?.sPackageOfferTitle === "Long Term Engagement Package"
										)
									) &&
									this.props?.serviceRequestReadOnlyData?.refExternalServicePartner !== "Mr. Sudhir Gijare" &&
									this.props?.serviceRequestReadOnlyData?.ext_sp_org !== "Mr. Sudhir Gijare" ?

									""
									:
							<p>
								{
									this.props.paymentURL && this.props.paymentStatus !== "Payment Link Deactivated" ? (
										<>
											<img
												alt="copy"
												title="Copy Payment Link"
												src={copysvg}
												height={"20px"}
												width={"16px"}
												className="con-cursor-pointer conv-mr13 conv-ml10"
												onClick={(e) => {
													e.preventDefault();

													if(this.props.paymentURL){
														copyToClipboard(this.props.paymentURL);
														toast(`Payment Link Copied!`, {
															autoClose: 5000,
															type: toast.TYPE.SUCCESS,
														})
													}else{
														toast(`No payment link found`, {
															autoClose: 5000,
															type: toast.TYPE.SUCCESS,
														})
													}
												}}
										/>
										{/* <small>(copy payment link)</small> */}
										</>
									) : ""
								}
							</p>
						}
						</div>
					)}
					{this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" &&
						(
							this.props?.serviceRequestReadOnlyData?.nPackageInstanceId === null ||
							(
								this.props?.serviceRequestReadOnlyData?.nPackageInstanceId !== null &&
								this.props?.serviceRequestReadOnlyData?.sPackageOfferTitle === "Long Term Engagement Package"
							)
						) &&
						this.props?.serviceRequestReadOnlyData?.refExternalServicePartner !== "Mr. Sudhir Gijare" &&
						this.props?.serviceRequestReadOnlyData?.ext_sp_org !== "Mr. Sudhir Gijare" ?

						""
						:
					<div
						className={`payment-color-label ${paymentStatus.replace(" ", "")} ${isPaymentLinkDisabled && "disabled"
							}`}
					>
						<small>
							<label>{paymentStatus}</label>
						</small>
					</div>
					}
				</div>
			</div>
		);
	};

	getChooseCatalogueView = (currentProgressionOrder) => {
		const isDisabled = currentProgressionOrder >= this.paymentReceivedOrder();
		return (
			<div
				id="openSelectCatalogueLPM"
				className={`underlined-action ml-1 mt-1 mb-2 ${this.props.deliveryMode === "Self-Served" && "disabled"
					}`}
				key={uniqueId()}
				onClick={this.props.togglCatalogueModal}
			>
				{this.props.isDisabled ? "View Selected Catalogue" : "Select Catalogue"}
			</div>
		);
	};

// 	isOptionDisabled = (state, currentProgressionOrder) => {
// 		const thresholdOrder = this.partialPendingOrder();
// 		if (state.sSRState === "Quotation Sent") {
// 			if (this.props.paymentMode != "SP_paid_service") {
// 				return true;
// 			}
// 		}

// 		if (state.sSRState === "Payment Received") {
// 			if (this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner") {
// 				return false;
// 			}

// 		}

// 		if (this.props.nPackageInstanceId === null) {
// 		console.log('this.props.packageType triggered nPackageInstanceId null')

// 			if (
// 				state.sSRState === "Partial/ Full Payment Pending" ||
// 				state.sSRState === "Payment Received"
// 			) {
// 				if (
// 					this.props.paymentMode === "SP_paid_service" ||
// 					this.props.paymentMode === "No_Payment" ||
// 					this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" && (this.props?.serviceRequestReadOnlyData?.refExternalServicePartner !== "Mr. Sudhir Gijare" ||
//   this.props?.serviceRequestReadOnlyData?.ext_sp_org !== "Mr. Sudhir Gijare") 
// 				) {
// 					return true;
// 				}
// 			}
// 		}
// 		console.log('this.props.packageType',this.props.packageType, this.props.nPackageInstanceId, this.props?.serviceRequestReadOnlyData?.sPaymentReceiver)
// 		if (this.props.nPackageInstanceId) {
// 		console.log('this.props.packageType triggered nPackageInstanceId')

// 			if (
// 				state.sSRState === "Partial/ Full Payment Pending" ||
// 				state.sSRState === "Payment Received"
// 			) {
// 				if (this.props.packageType === "Paid" || this.props.packageType === "Dynamic") {
// 		console.log('this.props.packageType triggered nPackageInstanceId 1')

// 					return false;
// 				}else if(this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "deAsra" && this.props.packageType === "Paid" || this.props.packageType === "Dynamic" || this.props.packageType === "Partner Paid"){
// 		console.log('this.props.packageType triggered nPackageInstanceId 2')

// 					return false;
// 				} else {
// 		console.log('this.props.packageType triggered nPackageInstanceId 3')

// 					return true
// 				}
// 			}
// 		}

// 		// if(this.props.sPackageOfferPaymentType === "Paid"){
// 		// 	if (
// 		// 		state.sSRState === "Partial/ Full Payment Pending" ||
// 		// 		state.sSRState === "Payment Received"
// 		// 	){
// 		// 			return false;
// 		// 	 }
// 		// }

// 		// if(!this.props.nPackageInstanceId)
// 		// {
// 		// 	if (
// 		// 		state.sSRState === "Partial/ Full Payment Pending" ||
// 		// 		state.sSRState === "Payment Received"
// 		// 	) {
// 		// 		if (
// 		// 			this.props.paymentMode === "No_Payment" ||
// 		// 			this.props.paymentMode === "SP_paid_service"
// 		// 		) {
// 		// 			return true;
// 		// 		}
// 		// 	}
// 		// }
// 		if (currentProgressionOrder >= thresholdOrder) {
// 			if (state.nOrder < thresholdOrder) return true;
// 			return false;
// 		} else {
// 			return false;
// 		}
// 	};

// 	isOptionDisabled = (state, currentProgressionOrder) => {
// 		const thresholdOrder = this.partialPendingOrder();
// 		if (state.sSRState === "Quotation Sent") {
// 			if (this.props.paymentMode != "SP_paid_service") {
// 				return true;
// 			}
// 		}

// 		if (state.sSRState === "Payment Received") {
// 			if (this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner") {
// 				return false;
// 			}

// 		}

// 		const serviceData = this.props.serviceRequestReadOnlyData;

// 		const isLongTermPackage =
// 			serviceData?.sPackageOfferTitle === "Long Term Engagement Package";

// 		const isSudhir =
// 			serviceData?.refExternalServicePartner === "Mr. Sudhir Gijare" ||
// 			serviceData?.ext_sp_org === "Mr. Sudhir Gijare";

// 		if (this.props.nPackageInstanceId === null || isLongTermPackage) {
// 			if (
// 				state.sSRState === "Partial/ Full Payment Pending" ||
// 				state.sSRState === "Payment Received"
// 			) {
// 				if (
// 					this.props.paymentMode === "SP_paid_service" ||
// 					this.props.paymentMode === "No_Payment" ||
// 					(isLongTermPackage && !isSudhir) ||
// 					(serviceData?.sPaymentReceiver === "Partner" && !isSudhir) ||
// 					this.props?.serviceRequestReadOnlyData?.sPaymentReceiver === "Partner" && (this.props?.serviceRequestReadOnlyData?.refExternalServicePartner !== "Mr. Sudhir Gijare" ||
//   this.props?.serviceRequestReadOnlyData?.ext_sp_org !== "Mr. Sudhir Gijare") 
// 				) {
// 					return true;
// 				}
// 			}
// 		}

// 		if (this.props.nPackageInstanceId && !isLongTermPackage) {
// 			if (
// 				state.sSRState === "Partial/ Full Payment Pending" ||
// 				state.sSRState === "Payment Received"
// 			) {
// 				if (this.props.packageType === "Paid" || this.props.packageType === "Dynamic" || this.props.packageType === "Partner Paid") {
// 					return false;
// 				} else {
// 					return true
// 				}
// 			}
// 		}

// 		// if(this.props.sPackageOfferPaymentType === "Paid"){
// 		// 	if (
// 		// 		state.sSRState === "Partial/ Full Payment Pending" ||
// 		// 		state.sSRState === "Payment Received"
// 		// 	){
// 		// 			return false;
// 		// 	 }
// 		// }

// 		// if(!this.props.nPackageInstanceId)
// 		// {
// 		// 	if (
// 		// 		state.sSRState === "Partial/ Full Payment Pending" ||
// 		// 		state.sSRState === "Payment Received"
// 		// 	) {
// 		// 		if (
// 		// 			this.props.paymentMode === "No_Payment" ||
// 		// 			this.props.paymentMode === "SP_paid_service"
// 		// 		) {
// 		// 			return true;
// 		// 		}
// 		// 	}
// 		// }
// 		if (currentProgressionOrder >= thresholdOrder) {
// 			if (state.nOrder < thresholdOrder) return true;
// 			return false;
// 		} else {
// 			return false;
// 		}
// 	};

	isOptionDisabled = (state, currentProgressionOrder) => {
		const thresholdOrder = this.partialPendingOrder();
		const serviceData = this.props?.serviceRequestReadOnlyData;

		const isLongTermPackage =
			serviceData?.sPackageOfferTitle === "Long Term Engagement Package";

		const isSudhir =
			serviceData?.refExternalServicePartner === "Mr. Sudhir Gijare" ||
			serviceData?.ext_sp_org === "Mr. Sudhir Gijare";

		const isPartner =
			serviceData?.sPaymentReceiver === "Partner";

		const isDeAsra =
			serviceData?.sPaymentReceiver === "deAsra";

		// Quotation Sent
		if (state.sSRState === "Quotation Sent") {
			if (this.props.paymentMode !== "SP_paid_service") {
				return true;
			}
		}

		// Payment Received
		if (state.sSRState === "Payment Received") {
			if (isPartner) {
				return false;
			}
		}

		// No package instance OR Long Term Engagement Package
		if (
			this.props.nPackageInstanceId === null ||
			isLongTermPackage
		) {
			if (
				state.sSRState === "Partial/ Full Payment Pending" ||
				state.sSRState === "Payment Received"
			) {
				if (
					this.props.paymentMode === "SP_paid_service" ||
					this.props.paymentMode === "No_Payment" ||

					// Long Term Engagement:
					// disable only when NOT deAsra and NOT Sudhir
					(
						isLongTermPackage &&
						!isDeAsra &&
						!isSudhir
					) ||

					// Partner:
					// disable only when NOT Sudhir
					(
						isPartner &&
						!isSudhir
					)
				) {
					return true;
				}
			}
		}

		// Normal package
		if (
			this.props.nPackageInstanceId &&
			!isLongTermPackage
		) {
			if (
				state.sSRState === "Partial/ Full Payment Pending" ||
				state.sSRState === "Payment Received"
			) {
				if (
					this.props.packageType === "Paid" ||
					this.props.packageType === "Dynamic" ||
					this.props.packageType === "Partner Paid"
				) {
					return false;
				} else {
					return true;
				}
			}
		}

		// Progression order
		if (currentProgressionOrder >= thresholdOrder) {
			if (state.nOrder < thresholdOrder) {
				return true;
			}

			return false;
		}

		return false;
	};

	renderRequestStates = (currentProgressionOrder) => {
		console.log("props==", this.props);
		const { masterServiceRequestStates } = this.props;
		const Arr = masterServiceRequestStates.sort((a, b) => {
			return a.nOrder - b.nOrder;
		});
		let newArr = Arr.shift();
		Arr.push(newArr);

		console.log("Master==", Arr);
		const view = [];
		sortBy(Arr).forEach((state, i) => {
			if (state.sSRState === "Partial/ Full Payment Pending") {
				const ctaView = this.getPaymentLinkAndNeftView(currentProgressionOrder);
				const catalogueView = this.getChooseCatalogueView(
					currentProgressionOrder
				);
				view.push(catalogueView);
				view.push(ctaView);
			}
			view.push(
				<Radio
					key={uniqueId()}
					name={state.sSRState}
					id={state.sSRState}
					disabled={
						this.isOptionDisabled(state, currentProgressionOrder) ||
						this.props.deliveryMode === "Self-Served" ||
						this.props.isDisabled === "disabled"
					}
					label={state.sSRState}
					checked={
						state.nOrder != 0
							? currentProgressionOrder >= state.nOrder
							: currentProgressionOrder === 0
					}
					onClick={(event) => {
						if (state.sSRState === "Cancelled") {
							this.props.toggleCancellationReasonModal();
						}
						//prevent pop-up from closing
						event.stopPropagation();
						this.setState({
							currentProgressionOrder: state.nOrder,
						});
					}}
					onChange={(event) => {
						//prevent pop-up from closing
						event.stopPropagation();
					}}
				/>
			);
		});
		return view;
	};

	getStateNameById = (order) => {
		const state = find(this.props.masterServiceRequestStates, {
			nOrder: order,
		});
		return state;
	};

	handleSave = () => {
		const state = this.getStateNameById(this.state.currentProgressionOrder);
		if (state) {
			this.props.onChangeState(state.sSRState);
		} else {
			console.error(
				"Invalid State. Are you sure you have access to this page?"
			);
		}
	};

	render() {
		const { currentProgressionOrder } = this.state;
		// const currentProgressionOrder = this.getProgressionOrder(this.props.currentState);
		return (
			<>
				<RequestStateUpdateModal
					isLoading={this.props.isLoading}
					isOpen={this.props.showServiceProgressionModal}
					toggleModal={() => {
						this.props.toggleServiceProgressionModal();
					}}
					renderMe={this.renderRequestStates(currentProgressionOrder)}
					deliveryMode={this.props.deliveryMode}
					isDisabled={this.props.isDisabled}
					isMovedToSPM={this.props.isMovedToSPM}
					handleSave={this.handleSave}
				/>

				<ConfirmationModalSmall
					message="The payment link with coupon code has expired. A full service payment link will be generated."
					isOpen={this.props.showConfirmationModal}
					toggleModal={this.props.toggleConfirmationModal}
					onPositive={this.props.onSendPaymentLink}
				/>
			</>
		);
	}
}

export default MyServiceRequestStatusProgression;
